import type { ContactContent } from '@/lib/content.types'
import { fluidHeadingSize } from '@/lib/typography'

export function Contact({ data }: { data: ContactContent }) {
  return (
    <section
      id="contact"
      className="relative overflow-hidden px-5 py-24 md:px-10 md:py-[112px]"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[820px] max-w-[130vw] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[26px]"
        style={{
          background:
            'radial-gradient(52% 54% at 44% 44%,rgba(46,144,250,.36),transparent 62%),radial-gradient(46% 48% at 62% 60%,rgba(95,18,204,.30),transparent 64%)',
        }}
      />
      <div className="relative mx-auto max-w-[720px] text-center">
        <h2
          // 줄간격은 Hero 큰 제목과 같은 값(leading-headline)을 쓴다
          className="mb-[18px] font-headline font-bold leading-headline tracking-headline"
          // Admin에서 정한 크기를 큰 화면 상한으로 쓰고, 좁은 화면에서는 자동 축소
          style={{ fontSize: fluidHeadingSize(data.headingSize) }}
        >
          {data.heading}
        </h2>
        <p className="mb-[34px] text-[17px] leading-[1.6] text-ink-secondary md:text-lg">
          {data.body}
        </p>
        {/* 높이는 .annx-cta 가 관리한다 — 상단 Hero 버튼과 정확히 같은 높이 */}
        <a
          href={data.cta.href}
          className="annx-cta rounded-[11px] px-[34px] text-base text-white shadow-cta-contact transition-[filter] hover:brightness-110"
          style={{ background: 'var(--accent)' }}
        >
          {data.cta.label}
        </a>
      </div>
    </section>
  )
}
